import { useParams } from "react-router-dom";
import { eventsData } from "../data/eventsData";
import { useState, useEffect } from "react";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(advancedFormat);

export default function Show() {
  const { id } = useParams();
  const show = eventsData.find((event) => event.id === +id);
  const [playbacks, setPlaybacks] = useState(null);
  const [durations, setDurations] = useState({});

  // Audio URL helper - uses Cloudflare Worker proxy for caching
  const getAudioUrl = (assetRef) => {
    if (!assetRef) return "";
    const filename = assetRef.replace("file-", "").replace("-mp3", ".mp3");
    // Using the Cloudflare Worker Proxy to save Sanity bandwidth
    return `https://happyradiouk.devmasters.workers.dev/${filename}`;
  };

  // Helper to format audio duration from seconds
  const formatAudioDuration = (seconds) => {
    if (!seconds) return "";
    const durationInMinutes = Math.round(seconds / 60);
    const hours = Math.floor(durationInMinutes / 60);
    const minutes = durationInMinutes % 60;
    return hours > 0 && minutes > 0
      ? `${hours} hour${hours > 1 ? "s" : ""} ${minutes} minute${minutes > 1 ? "s" : ""}`
      : hours > 0
        ? `${hours} hour${hours > 1 ? "s" : ""}`
        : `${minutes} minute${minutes > 1 ? "s" : ""}`;
  };

  useEffect(() => {
    if (!show) return;

    // Fetch playbacks from Sanity using REST API - sorted by most recent, limit 5
    const query = `*[_type == "playback" && showId == ${show.id}] | order(broadcastDateTime desc) [0...5]`;
    const encodedQuery = encodeURIComponent(query);

    fetch(
      `https://wtagmpvu.apicdn.sanity.io/v2025-10-24/data/query/production?query=${encodedQuery}&perspective=published`,
    )
      .then((response) => response.json())
      .then((data) => {
        // console.log(data.result);
        setPlaybacks(data.result);
      })
      .catch((error) => {
        console.error("Error fetching playbacks:", error);
      });
  }, [show]);

  if (!show) {
    return <div className="container mx-auto px-4 py-8">Show not found</div>;
  }

  // console.log(playbacks);

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="bg-white rounded-md shadow-md overflow-hidden flex flex-col md:flex-row p-8 gap-6">
        <div className="relative max-h-64 max-w-64">
          <img
            src={show.playbackImage || show.image}
            alt={show.title}
            className="card w-full object-cover"
          />
        </div>
        <div className="flex flex-col justify-center gap-2">
          <h1 className="text-3xl font-bold text-gray-900 text-left mb-0 pb-0">
            {show.name}
          </h1>
          {/* <div className="">
            <span className="text-gray-600 font-semibold">Show Description: </span>
            <span className="text-gray-800">{show.presenter}</span>
          </div> */}
          <p className="text-gray-700 leading-relaxed">{show.description}</p>
          {/* <div className="">
            <span className="text-gray-600 font-semibold">Time: </span>
            <span className="text-gray-800">{show.time}</span>
          </div> */}
          <div className="">
            {/* <span className="text-gray-600 font-semibold">Day: </span> */}
            <span className="text-gray-800 font-semibold">
              Every {show?.day?.join(", ")} at {show.time}:00
            </span>
          </div>
          {/* LISTEN AGAIN SECTION */}
          {playbacks && playbacks.length > 0 && (
            <div className="mt-8">
              <h2 className="text-xl font-bold text-gray-900 pb-4 border-b border-gray-200">
                Listen Again
              </h2>
              {playbacks.sort().map((playback) => (
                <div
                  key={playback._id}
                  className="border-b border-gray-200 pb-4 flex gap-2"
                >
                  {/* <div>
                    <img src={'/schedule/Happy Radio.jpeg'} alt={`${playback.title} Listen Again`} className="w-24 h-24 object-cover" />
                  </div> */}
                  <div className="my-2 overflow-x-auto">
                    {/* <h3 className="text-lg font-bold text-gray-900">{playback.title}</h3> */}
                    {durations[playback._id] && (
                      <p className="text-gray-700 font-semibold leading-relaxed">
                        {durations[playback._id]}
                      </p>
                    )}
                    <p className="text-gray-700 leading-relaxed">
                      Broadcast{" "}
                      {dayjs(playback.broadcastDateTime).format(
                        "ddd Do MMM HH:mm",
                      )}
                    </p>
                    {playback.audioFile &&
                      playback.audioFile.asset &&
                      playback.audioFile.asset._ref && (
                        <audio
                          controls
                          preload="none"
                          className="mt-2"
                          onLoadedMetadata={(e) => {
                            const formatted = formatAudioDuration(
                              e.target.duration,
                            );
                            setDurations((prev) => ({
                              ...prev,
                              [playback._id]: formatted,
                            }));
                          }}
                        >
                          <source
                            src={getAudioUrl(playback.audioFile.asset._ref)}
                            type="audio/mpeg"
                          />
                          Your browser does not support the audio element.
                        </audio>
                      )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
